import React, { useState, useEffect } from "react";
import NavbarDev, { loadNav } from "./Navbar";
import Loader from "../../components/Loader";
import Alert from "../../components/Alert";
import { useNavigate } from "react-router-dom";

const LogDB = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState(null);
    const navigate = useNavigate();
    const [showAlert, setShowAlert] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ type: "info", text: "", onClose: () => setShowAlert(false), needConfirm: false, onConfirm: () => { } });

    useEffect(() => {
        onload();
    }, []);

    const onload = async () => {
        setIsLoading(true);
        try {
            await loadNav();

            const r2 = await fetch("/getLogDB", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            const rd2 = await r2.json();

            if (r2.status === 500) {
                console.log(rd2.error);
                setAlertInfo({ type: "error", text: rd2.error, onClose: () => { setShowAlert(false); navigate('/dev/dash'); }, needConfirm: false });
                setShowAlert(true);
            } else {
                console.log(rd2);
                setData(rd2.log);
            }

        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nel caricamento della pagina, riprova più tardi", onClose: () => { navigate("/dev/dash"); }, needConfirm: false });
            setShowAlert(true);
        }

        setIsLoading(false);
    };

    return (
        <div className="h-[100svh]">
            <NavbarDev page={"LOG DATABASE"} />
            {isLoading && <Loader />}
            {showAlert && <Alert type={alertInfo.type} text={alertInfo.text} onClose={alertInfo.onClose} needConfirm={alertInfo.needConfirm} onConfirm={alertInfo.onConfirm} />}
            <div className="h-[93%] overflow-y-auto flex flex-col justify-center items-center px-8 pt-8 pb-4">
                <div className="h-full w-full p-4 bg-gray-200 dark:bg-neutral-800 rounded-lg font-mono">
                    {data && data.length > 0 ? (
                        data.map((line, index) => (
                            <div key={index} className="whitespace-pre-wrap">
                                {line}
                            </div>
                        ))
                    ) : (
                        <div>Nessun dato di log disponibile.</div>
                    )}
                </div>
            </div>
        </div>
    )
};
export default LogDB;